/**
 * Generates unique Alert IDs in the format A-YYYY-NNN
 * Example: A-2025-001, A-2025-002, etc.
 */

let alertCounter = 0;

export function generateAlertId(): string {
  alertCounter++;
  const year = new Date().getFullYear();
  const sequence = String(alertCounter).padStart(3, '0');
  return `A-${year}-${sequence}`;
}

export function resetAlertCounter(): void {
  alertCounter = 0;
}

